import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import AssetSubscriptionPlanView from "@/common/components/Entity/AssetSubscriptionPlan/View/AssetSubscriptionPlanView";
import { ViewVariant } from "@/common/ts/layout";
import { AssetSubscriptionDto } from "@/core/api/generated/v1";

interface Props {
  assetSubscription: AssetSubscriptionDto;
}

export default function OverviewTabContent({ assetSubscription }: Props) {
  return (
    <PageTabContent>
      <AssetSubscriptionPlanView
        assetSubscriptionPlanId={assetSubscription.plan?.id}
        assetSubscriptionPlan={undefined}
        displayProps={{
          breadcrumbs: false,
          header: false,
          actions: false,
          viewVariant: ViewVariant.Tab,
        }}
        headerProps={{
          withLink: true,
          typographyProps: pageTabHeaderTypographyProps.title,
        }}
        onDelete={null}
      />
    </PageTabContent>
  );
}
